import { render } from "./BetsOperations.vue?vue&type=template&id=f05980e6"
import script from "./BetsOperations.vue?vue&type=script&lang=js"
export * from "./BetsOperations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__